module.exports = __webpack_public_path__ + "static/grid-image-sm-bfb4e352a395f01a8fd23feb8a357e1b.png";